"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioBox = exports.BtnsBox = exports.CheckBox = exports.BoxItem = void 0;
const gs = require("..");
class BoxItem extends gs.WrapperGS {
    constructor(el) {
        super(el);
    }
    get value() { return this.attr("value"); }
    set value(value) { this.setData("value", value); }
}
exports.BoxItem = BoxItem;
BoxItem.TagClassName = 'gs-boxitem';
class CheckBox extends gs.WrapperGS {
    constructor(el) {
        super(el);
        this._onItemSelectedToken = new gs.EventGSToken();
        this._onItemClickedToken = new gs.EventGSToken();
        this.onItemSelected = new gs.EventGS(this._onItemSelectedToken);
        this.onItemClicked = new gs.EventGS(this._onItemClickedToken);
        if (!this.hasClass(CheckBox.TagClassName))
            throw new Error("Trying create CheckBox from HTMLElement without specific class in classList");
        this.onclick = (e) => this.handlerClick(e);
    }
    inactiveAll() { this.getItems().forEach((item) => item.inactive()); }
    activeByValue(val, invokeEvent = true) {
        this.getItems().filter(i => i.value === val).forEach((i) => this.activeItem(i, invokeEvent));
    }
    get value() {
        return this.getActiveItems().map((i) => i.value);
    }
    set value(value) {
        this.inactiveAll();
        this.getItems().forEach(i => {
            if (!i.value)
                return;
            if (value.indexOf(i.value) < 0)
                return;
            i.active();
        });
    }
    getAllValues() {
        const result = [];
        this.getItems().forEach((item) => { if (item.value)
            result.push(item.value); });
        return result;
    }
    getActiveItem() { return this.getActiveItems()[0]; }
    getActiveItems() { return this.getItems().filter((i) => i.isActive); }
    getItems() { return this.q("." + BoxItem.TagClassName).all.map(c => gs.def.toType(c, BoxItem)).filter(b => b); }
    getItemByValue(cbvalue) { return this.getItems().filter((i) => i.value === cbvalue)[0]; }
    //*Private*//
    handlerClick(e) {
        const item = gs.def.toType(gs.w(e.target), BoxItem);
        if (!item)
            return;
        if (item.isActive)
            item.inactive();
        else
            this.activeItem(item, true);
        this._onItemClickedToken.invoke(item);
    }
    ;
    activeItem(item, invokeEvent = true) {
        if (item.isActive)
            return;
        item.active();
        if (invokeEvent) {
            this._onItemSelectedToken.invoke(item);
            this.el.dispatchEvent(new Event('input'));
        }
    }
    ;
}
exports.CheckBox = CheckBox;
CheckBox.TagClassName = 'gs-checkbox';
class BtnsBox extends gs.WrapperGS {
    constructor(el) {
        super(el);
        this._onItemClickedToken = new gs.EventGSToken();
        this.onItemClicked = new gs.EventGS(this._onItemClickedToken);
        if (!this.hasClass(BtnsBox.TagClassName))
            throw new Error("Trying create BtnsBox from HTMLElement without specific class in classList");
        this.onclick = (e) => this.handlerClick(e);
    }
    getAllValues() {
        const result = [];
        this.getItems().forEach((item) => { if (item.value)
            result.push(item.value); });
        return result;
    }
    getItems() { return this.q("." + BoxItem.TagClassName).all.map(c => gs.def.toType(c, BoxItem)).filter(b => b); }
    getItemByValue(cbvalue) { return this.getItems().filter((i) => i.value === cbvalue)[0]; }
    //*Private*//
    handlerClick(e) {
        const item = gs.def.toType(gs.w(e.target), BoxItem);
        if (!item)
            return;
        this._onItemClickedToken.invoke(item);
    }
    ;
}
exports.BtnsBox = BtnsBox;
BtnsBox.TagClassName = 'gs-btnsbox';
class RadioBox extends gs.WrapperGS {
    constructor(el) {
        super(el);
        this._onItemSelectedToken = new gs.EventGSToken();
        this.onItemSelected = new gs.EventGS(this._onItemSelectedToken);
        if (!this.hasClass(RadioBox.TagClassName))
            throw new Error("Trying create RadioBox from HTMLElement without specific class in classList");
        this.onclick = (e) => this.handlerClick(e);
    }
    inactiveAll() { this.getItems().forEach((item) => item.inactive()); }
    activeByValue(val, invokeEvent = true) {
        this.inactiveAll();
        this.getItems().filter(i => i.value === val).forEach((i) => this.activeItem(i, invokeEvent));
    }
    get value() { const item = this.getActiveItem(); if (item)
        return item.value;
    else
        return undefined; }
    set value(value) { this.activeByValue(value); }
    getAllValues() {
        const result = [];
        this.getItems().forEach((item) => { if (item.value)
            result.push(item.value); });
        return result;
    }
    getActiveItem() { return this.getItems().filter((i) => i.isActive)[0]; }
    getItems() { return this.q("." + BoxItem.TagClassName).all.map(c => gs.def.toType(c, BoxItem)).filter(b => b); }
    getItemByValue(cbvalue) { return this.getItems().filter((i) => i.value === cbvalue)[0]; }
    //*Private*//
    handlerClick(e) {
        const item = gs.def.toType(gs.w(e.target), BoxItem);
        if (!item)
            return;
        this.inactiveAll();
        this.activeItem(item, true);
    }
    ;
    activeItem(item, invokeEvent = true) {
        if (item.isActive)
            return;
        item.active();
        if (invokeEvent) {
            this._onItemSelectedToken.invoke(item);
            this.el.dispatchEvent(new Event('input'));
        }
    }
    ;
}
exports.RadioBox = RadioBox;
RadioBox.TagClassName = 'gs-radiobox';
gs.WrapperGS.ExtendComponentsByTagClass(BoxItem);
gs.WrapperGS.ExtendComponentsByTagClass(CheckBox);
gs.WrapperGS.ExtendComponentsByTagClass(BtnsBox);
gs.WrapperGS.ExtendComponentsByTagClass(RadioBox);
//# sourceMappingURL=BoxesGS.js.map